import { getApiUrl } from './apiConfig';

export const fetchStudentDetails = async (userId) => {
  try {
    const response = await fetch(getApiUrl(`student-details?user_id=${userId}`));
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching student details:', error);
    return null;
  }
};
